import { render, staticRenderFns } from "./CTAFields.vue?vue&type=template&id=0bb08b7a&"
import script from "./CTAFields.vue?vue&type=script&lang=js&"
export * from "./CTAFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports